<template>
  <div class="reject-statsheet-page">
    <HubSpotStatsheetRejectionForm />
  </div>
</template>

<script>
import HubSpotStatsheetRejectionForm from '@/components/HubSpotStatsheetRejectionForm.vue';

export default {
  name: 'RejectStatsheet',
  components: {
    HubSpotStatsheetRejectionForm
  },
}
</script>

<style lang="scss" scoped>
.reject-statsheet-page {
  max-width: 700px;
  width: 100%;
  padding: 32px 24px;
  margin: 2.5rem auto;
  background: $color-surface;
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(170, 118, 214, 0.07);
  box-sizing: border-box;
}

@media screen and (max-width: 900px) {
  .reject-statsheet-page {
    max-width: 100%;
    padding: 1.2rem 0.5rem;
    margin: 1.2rem 0;
    border-radius: 0.7rem;
    box-shadow: 0 1px 6px rgba(170, 118, 214, 0.10);
  }
}
</style>

